import { useReactiveVar } from "@apollo/client";
import { faBook, faBorderAll, faHome, faSearch, faUser } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { useHistory } from "react-router";
import { userMenuVar } from "../apollo";
import { UserMenu } from "../constants";

export const SideBar = () => {
  const history = useHistory();
  const userMenu = useReactiveVar(userMenuVar);
  const handleClickMenu = (menu: UserMenu) => {
    userMenuVar(menu);
    if (UserMenu.Home === menu) {
      history.push("/home");
    } else if (UserMenu.Subscriptions === menu) {
      history.push("/subscriptions");
    } else if (UserMenu.Category === menu) {
      history.push("/category");
    } else if (UserMenu.Profile === menu) {
      history.push("/profile");
    } else if (UserMenu.Search === menu) {
      history.push("/search");
    }
  };
  return (
    <>
      <div className="hidden md:block">
        <div className="float-left bg-gray-700 w-48 h-screen">
          <div className="hidden md:block py-10 px-2 overflow-hidden">
            <button
              className={`mb-5 flex justify-center items-center text-gray-400 ${userMenu === UserMenu.Category ? "text-purple-900" : ""} `}
              onClick={() => handleClickMenu(UserMenu.Category)}
            >
              <FontAwesomeIcon icon={faBorderAll} className="text-xl mb-1 mr-2" />
              <span className="text-xs font-bold">Category</span>
            </button>
            <button
              className={`mb-5 flex justify-center items-center text-gray-400 ${
                userMenu === UserMenu.Subscriptions ? "text-purple-900" : ""
              } `}
              onClick={() => handleClickMenu(UserMenu.Subscriptions)}
            >
              <FontAwesomeIcon icon={faBook} className="text-xl mb-1 mr-2" />
              <span className="text-xs font-bold">Subscriptions</span>
            </button>
            <button
              className={`mb-5 flex justify-center items-center text-gray-400 ${userMenu === UserMenu.Home ? "text-purple-900" : ""} `}
              onClick={() => handleClickMenu(UserMenu.Home)}
            >
              <FontAwesomeIcon icon={faHome} className="text-xl mb-1 mr-2" />
              <span className="text-xs font-bold">Home</span>
            </button>
            <button
              className={`mb-5  flex justify-center items-center text-gray-400 ${userMenu === UserMenu.Search ? "text-purple-900" : ""} `}
              onClick={() => handleClickMenu(UserMenu.Search)}
            >
              <FontAwesomeIcon icon={faSearch} className="text-xl mb-1 mr-2" />
              <span className="text-xs font-bold">Search</span>
            </button>
            <button
              className={`mb-5 flex justify-center items-center text-gray-400 ${userMenu === UserMenu.Profile ? "text-purple-900" : ""} `}
              onClick={() => handleClickMenu(UserMenu.Profile)}
            >
              <FontAwesomeIcon icon={faUser} className="text-xl mb-1 mr-2" />
              <span className="text-xs font-bold">Profile</span>
            </button>
          </div>
        </div>
      </div>

      <div className="md:hidden">
        <div className="absolute w-full bottom-0 bg-gray-700">
          <div className="grid grid-cols-5 gap-2 py-3">
            <button
              className={`flex flex-col items-center text-gray-400 ${userMenu === UserMenu.Category ? "text-purple-900" : ""} `}
              onClick={() => handleClickMenu(UserMenu.Category)}
            >
              <FontAwesomeIcon icon={faBorderAll} className="text-xl mb-1" />
              <span className="text-xs font-bold">Category</span>
            </button>
            <button
              className={`flex flex-col items-center text-gray-400 ${userMenu === UserMenu.Subscriptions ? "text-purple-900" : ""} `}
              onClick={() => handleClickMenu(UserMenu.Subscriptions)}
            >
              <FontAwesomeIcon icon={faBook} className="text-xl mb-1" />
              <span className="text-xs font-bold">Subscriptions</span>
            </button>
            <button
              className={`flex flex-col items-center text-gray-400 ${userMenu === UserMenu.Home ? "text-purple-900" : ""} `}
              onClick={() => handleClickMenu(UserMenu.Home)}
            >
              <FontAwesomeIcon icon={faHome} className="text-xl mb-1" />
              <span className="text-xs font-bold">Home</span>
            </button>
            <button
              className={`flex flex-col items-center text-gray-400 ${userMenu === UserMenu.Search ? "text-purple-900" : ""} `}
              onClick={() => handleClickMenu(UserMenu.Search)}
            >
              <FontAwesomeIcon icon={faSearch} className="text-xl mb-1" />
              <span className="text-xs font-bold">Search</span>
            </button>
            <button
              className={`flex flex-col items-center text-gray-400 ${userMenu === UserMenu.Profile ? "text-purple-900" : ""} `}
              onClick={() => handleClickMenu(UserMenu.Profile)}
            >
              <FontAwesomeIcon icon={faUser} className="text-xl mb-1" />
              <span className="text-xs font-bold">Profile</span>
            </button>
          </div>
        </div>
      </div>
    </>

    // // <div className=" absolute bottom-0 w-full bg-gray-800 border-black border-t-2 md:float-left md:w-48 md:t-0 md:h-screen md:border-r-2">
    // <div className="bottom-0 w-full md:block md:float-left md:w-48 md:h-screen bg-gray-700 border-gray-500 md:border-r-2">
    //   <div className="hidden md:block py-10 px-2 overflow-hidden">
    //     <form className="flex items-center rounded-lg px-2 py-1  bg-transparent shadow-inner bg-gray-600 transition-colors focus:outline-none focus:border-purple-700 mb-1">
    //       <button type="submit">
    //         <FontAwesomeIcon icon={faSearch} className="text-sm text-gray-800" />
    //       </button>
    //       <input
    //         id="search-input"
    //         autoComplete="off"
    //         placeholder="Search"
    //         className="bg-transparent focus:outline-none text-white text-sm px-2 py-0.5"
    //       />
    //       <FontAwesomeIcon icon={faTimesCircle} className="text-sm text-gray-800 cursor-pointer" />
    //     </form>
    //   </div>

    //   <div className="flex md:hidden py-3 justify-center">
    //     <div className=" flex flex-col items-center text-gray-400">
    //       <FontAwesomeIcon icon={faBorderAll} className="text-2xl" />
    //       <span className="text-xs">Browse</span>
    //     </div>
    //     <Link to="" className=" flex flex-col items-center text-gray-400">
    //       <FontAwesomeIcon icon={faBook} className="text-2xl" />
    //       <span className="text-xs">Library</span>
    //     </Link>
    //     <div>Search</div>
    //   </div>
    // </div>
  );
};
